import { motion } from 'framer-motion'
import { Star, Quote } from 'lucide-react'
import { TESTIMONIALS_STATS } from '../constants/stats'

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Александр Петров',
      car: 'Geely Coolray 2023',
      rating: 5,
      text: 'Отличная работа! Машина обработана качественно, все детали промазаны. Прошло уже 2 года - никаких признаков коррозии. Рекомендую всем!',
      date: '2 года назад'
    },
    {
      name: 'Мария Сидорова',
      car: 'BYD Song L 2024',
      rating: 5,
      text: 'Очень довольна результатом. Мастера работают аккуратно, все объяснили по процессу. Цена соответствует качеству. Обязательно приеду еще раз.',
      date: '1 год назад'
    },
    {
      name: 'Дмитрий Козлов',
      car: 'Belgee x50 2024',
      rating: 5,
      text: 'Профессиональный подход к делу. Машину обработали за 3 часа, все сделано на совесть. Гарантия дали на 5 лет - это говорит о многом.',
      date: '6 месяцев назад'
    },
    {
      name: 'Елена Волкова',
      car: 'BYD Song Plus 2025',
      rating: 5,
      text: 'Приятно удивлена качеством работы. Машина выглядит как новая, все защищено от коррозии. Спасибо за внимательность к деталям!',
      date: '3 месяца назад'
    },
    {
      name: 'Сергей Иванов',
      car: 'Geely Monjaro 2025',
      rating: 5,
      text: 'Лучший сервис в городе! Работают быстро, качественно и c гарантией. Уже третий раз обращаюсь, всегда доволен результатом.',
      date: '1 месяц назад'
    },
    {
      name: 'Анна Морозова',
      car: 'Geely EX5 2025',
      rating: 5,
      text: 'Очень качественная работа. Мастера настоящие профессионалы своего дела. Все сделано аккуратно, никаких подтеков. Рекомендую!',
      date: '2 недели назад'
    }
  ]

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`w-5 h-5 ${
          i < rating ? 'text-accent-500 fill-current' : 'text-secondary-300'
        }`}
      />
    ))
  }

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 mb-4">
            Отзывы наших клиентов
          </h2>
          <p className="text-lg text-secondary-600 max-w-3xl mx-auto">
            Мы гордимся тем, что наши клиенты довольны качеством работы.
            Вот что они говорят о наших услугах
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
            >
              <div className="card h-full hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 relative">
                {/* Quote Icon */}
                <div className="absolute -top-4 -left-4 w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center">
                  <Quote className="w-4 h-4 text-white" />
                </div>

                {/* Rating */}
                <div className="flex items-center mb-4">
                  {renderStars(testimonial.rating)}
                  <span className="ml-2 text-sm text-secondary-500">
                    {testimonial.rating}.0
                  </span>
                </div>

                {/* Text */}
                <blockquote className="text-secondary-700 mb-6 italic leading-relaxed">
                  "{testimonial.text}"
                </blockquote>

                {/* Author Info */}
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-semibold text-secondary-900">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-secondary-600">
                      {testimonial.car}
                    </div>
                  </div>
                  <div className="text-sm text-secondary-500">
                    {testimonial.date}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Overall Rating */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <div className="bg-gradient-to-r from-primary-50 to-accent-50 rounded-2xl p-8 md:p-12">
            <div className="flex items-center justify-center mb-4">
              {renderStars(5)}
              <span className="ml-3 text-2xl font-bold text-secondary-900">
                5.0
              </span>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-secondary-900 mb-4">
              Средняя оценка наших услуг
            </h3>
            <p className="text-lg text-secondary-600 mb-6 max-w-2xl mx-auto">
              Наши клиенты высоко ценят качество работы и профессионализм.
              Мы стремимся поддерживать высокий стандарт качества
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-2xl mx-auto">
              {TESTIMONIALS_STATS.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-3xl font-bold text-primary-600 mb-2">{stat.number}</div>
                  <div className="text-secondary-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-center mt-12"
        >
          <p className="text-lg text-secondary-600 mb-6">
            Присоединяйтесь к числу довольных клиентов!
          </p>
          <button className="btn-primary">
            Оставить отзыв
          </button>
        </motion.div>
      </div>
    </section>
  )
}

export default Testimonials
